import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { queries } from '../../graphql/graphql';

import { Question } from '../Questions/index';

import axios from 'axios';

const AnswerForSpecifications = ({ templateId, prefix, onChange, value, ...rest }) => {
  const [fields, setFields] = useState([]);
  const { data = {} } = useQuery(queries.TEMPLATE, { variables: { id: templateId } });
  const { template } = data;

  useEffect(() => {
    if (template && template.typeformId) {
      axios({
        method: 'post',
        url: '/api/typeform/form',
        data: {
          uid: template.typeformId
        }
      }).then(function(response) {
        if (response.status === 200) {
          setFields(response.data.fields);
          const templateSpecification = template.specifications[prefix];
          if (templateSpecification && !value.length) {
            onChange(templateSpecification);
          } else if (templateSpecification && value) {
            const newSpecs = [].concat(value);
            templateSpecification.forEach(v => {
              if (!newSpecs.find(s => s.id === v.id)) {
                newSpecs.push(v);
              }
            });
            onChange(newSpecs);
          }
        } else {
          console.log(response);
        }
      });
    }
  }, [data]);

  const onChangeQuestion = (result, index) => {
    const newValue = [...value];
    newValue[index].value = result;
    onChange(newValue);
  };

  return (
    <>
      Specifications
      <br />
      {value &&
        fields.length &&
        value.map((item, index) => (
          <Question
            key={item.id}
            item={item}
            questions={fields}
            onChange={data => onChangeQuestion(data, index)}
          />
        ))}
    </>
  );
};

export default AnswerForSpecifications;
